import React, { Component } from 'react'
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import './Interactions.css'
import { isImage } from "../../Material/DocumentModal/utils"
import toTitleCase from "../../Functions/toTitleCase"

class AttachmentViewer extends Component {
    render() {
        const { open, attachment, handleClose } = this.props
        const { document: name, contentType, content, url, documentType } = attachment

        const getDataSource = () => {
            if (url) return url
            if (content) return `data:${contentType};base64,${content}`
            return null
        }

        const renderMedia = (source) => {
            return isImage(url, name) ? (
                <img style={{ width: 'auto', maxWidth: '100%', maxHeight: '70vh' }} src={source} alt={name} />
            ) : (
                <iframe
                    src={source}
                    title={name}
                    width="100%"
                    height="600px"
                    style={{ border: 'none' }}
                ></iframe>
            )
        }

        const contentSource = getDataSource()
        return (
            <Modal isOpen={open} className="attachment-viewer-modal">
                <ModalHeader>{toTitleCase(typeof documentType === 'string' ? documentType : name)}</ModalHeader>
                <ModalBody>
                    {contentSource ? renderMedia(contentSource) : <p>No attachment available</p>}
                </ModalBody>
                <ModalFooter>
                    <Button onClick={handleClose}>Close</Button>
                </ModalFooter>
            </Modal>
        )
    }
}

export default AttachmentViewer
